module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Traffic (Selected Period for Comparison)"}}')
  delete Component.options._Ctor
}
